<template>
  <div>

      <b-field label="Sélection du salarié">
        <b-autocomplete
            v-model="userInputEmployee"
            :data="filteredEmployeeArray"
            placeholder="ex. Jean-Michel"
            icon="user"
            field="user.fullName"
            clearable
            @select="action">
          <template #empty>Pas de résultats</template>
          <template slot-scope="props">
            <div class="media-content">
              {{ props.option.user.fullName }}

              <small>
                <em>( user : {{ props.option.user.id }}, employee : {{ props.option.id }} )</em>
              </small>

            </div>
          </template>
        </b-autocomplete>
      </b-field>

    </div>
</template>

<script>

export default {
  name: "SelectEmployee",
  mounted() {

    this.$axios.get(`getEmployeesList`)
        .then(response => {
          this.employeeList = response.data.allEmployees;
        })
        .catch(e => {
          console.log(e);
        });
  },
  computed: {

    filteredEmployeeArray() {
      return this.employeeList.filter((option) => {
        return option.user.fullName
            .toString()
            .toLowerCase()
            .indexOf(this.userInputEmployee.toLowerCase()) >= 0
      })
    }

  },
  watch: {

  },
  methods: {

    action(option) {
      this.selectedEmployee = option
      this.$emit('updateEmployee', option);
    }

  },
  data() {
    return {
      employeeList: [],
      userInputEmployee: '',
      selectedEmployee: null
    }
  }
}
</script>

<style scoped>

</style>
